import React from 'react';
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  IconButton,
  Tooltip,
} from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import { User } from '../../services/api';
import UserRoles from './UserRoles';

interface UsersTableProps {
  users: User[];
  availableRoles: string[];
  onRoleChange: (username: string, role: string, checked: boolean) => void;
  onDeleteUser: (username: string) => void;
}

const UsersTable: React.FC<UsersTableProps> = ({
  users,
  availableRoles,
  onRoleChange,
  onDeleteUser,
}) => {
  return (
    <TableContainer component={Paper}>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Username</TableCell>
            <TableCell>Email</TableCell>
            <TableCell>Status</TableCell>
            <TableCell>Actions</TableCell>
            <TableCell>Roles</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {users.map(user => (
            <TableRow key={user.username}>
              <TableCell>{user.username}</TableCell>
              <TableCell>{user.attributes?.email ?? user.username}</TableCell>
              <TableCell>{user.userStatus ?? 'Unknown'}</TableCell>
              <TableCell>
                {(() => {
                  const isDisabled =
                    user.roles.includes('SystemAdministrators') &&
                    users.filter(u => u.roles.includes('SystemAdministrators')).length <= 1;

                  const deleteButton = (
                    <IconButton
                      aria-label="delete"
                      onClick={() => onDeleteUser(user.username)}
                      disabled={isDisabled}
                    >
                      <DeleteIcon />
                    </IconButton>
                  );

                  return (
                    <Tooltip
                      title={
                        isDisabled ? 'Cannot delete the last system administrator' : 'Delete User'
                      }
                    >
                      {isDisabled ? <span>{deleteButton}</span> : deleteButton}
                    </Tooltip>
                  );
                })()}
              </TableCell>
              <TableCell>
                <UserRoles
                  user={user}
                  availableRoles={availableRoles}
                  users={users}
                  onRoleChange={onRoleChange}
                />
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default UsersTable;
